<template>
  <div
    v-click-outside="closeDropdown"
    class="dropdown-actions"
    @click.stop=""
  >
    <div
      v-if="labelText"
      class="dropdown-actions__container"
      @click.stop="toggleDropdown"
    >
      <span class="dropdown-actions__label">{{ labelText }}</span>
      <div
        :class="['status-icon', triggerIconClass, 'm-0']"
        :style="triggerStyle"
      >
        <md-tooltip
          md-delay="400"
          :md-direction="tooltipDirection"
        >
          {{ tooltipText }}
        </md-tooltip>
      </div>
    </div>

    <div
      v-else
      :class="['status-icon', triggerIconClass, 'm-0']"
      :style="triggerStyle"
      @click.stop="toggleDropdown"
    >
      <md-tooltip
        md-delay="400"
        :md-direction="tooltipDirection"
      >
        {{ tooltipText }}
      </md-tooltip>
    </div>

    <div
      v-if="showDropdown"
      class="dropdown-menu"
      @click.stop=""
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        class="dropdown-item"
        @click="handleItemClick(item)"
      >
        <i
          v-if="item.icon"
          :class="item.icon"
        />
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { clickOutside } from '@/utils/directives';

export default {
  name: 'DropdownActions',
  directives: {
    clickOutside,
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: items => {
        return items.every(item => item && typeof item.label === 'string' && typeof item.action === 'function');
      },
    },
    triggerIconClass: {
      type: String,
      default: 'icon-download-alt',
    },
    triggerBackgroundColor: {
      type: String,
      default: '',
    },
    triggerIconSize: {
      type: [Number, String],
      default: 24,
    },
    dropdownItemIconSize: {
      type: [Number, String],
      default: 22,
    },
    dropdownMinWidth: {
      type: [Number, String],
      default: 180,
    },
    labelText: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      default: 'Ações',
    },
    tooltipDirection: {
      type: String,
      default: 'left',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value),
    },
  },
  data() {
    return {
      showDropdown: false,
    };
  },
  computed: {
    triggerStyle() {
      const size = typeof this.triggerIconSize === 'number' ? `${this.triggerIconSize}px` : this.triggerIconSize;
      return {
        backgroundColor: this.triggerBackgroundColor,
        width: size,
        height: size,
        '--hover-color': this.triggerHoverColor,
        '--dropdown-min-width': this.dropdownMinWidthValue,
        '--dropdown-item-icon-size': this.dropdownItemIconSizeValue,
      };
    },
    triggerHoverColor() {
      if (this.triggerBackgroundColor === 'transparent') {
        return 'rgba(0, 0, 0, 0.1)';
      }
      if (this.triggerBackgroundColor === '#7f1a54') {
        return '#5d1240';
      }
      return this.triggerBackgroundColor;
    },
    dropdownMinWidthValue() {
      return typeof this.dropdownMinWidth === 'number' ? `${this.dropdownMinWidth}px` : this.dropdownMinWidth;
    },
    dropdownItemIconSizeValue() {
      return typeof this.dropdownItemIconSize === 'number' ? `${this.dropdownItemIconSize}px` : this.dropdownItemIconSize;
    },
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    handleItemClick(item) {
      if (item.action && typeof item.action === 'function') {
        item.action();
      }
      this.closeDropdown();
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-actions {
  position: relative;
  display: inline-block;

  &__container {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    user-select: none;
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    white-space: nowrap;
    transition: color 0.2s ease;

    &:hover {
      color: #555;
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: var(--dropdown-min-width, 180px);
    margin-top: 5px;

    &::before {
      content: '';
      position: absolute;
      top: -8px;
      right: 12px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid white;
    }

    &::after {
      content: '';
      position: absolute;
      top: -9px;
      right: 12px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #ddd;
    }

    .dropdown-item {
      padding: 12px 16px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      transition: background-color 0.2s ease;
      font-size: 14px;
      color: #333;

      &:hover {
        background-color: #f5f5f5;
      }

      &:first-child {
        border-radius: 4px 4px 0 0;
      }

      &:last-child {
        border-radius: 0 0 4px 4px;
      }

      i {
        width: var(--dropdown-item-icon-size, 16px);
        height: var(--dropdown-item-icon-size, 16px);
        opacity: 0.7;
        flex-shrink: 0;
        background-position: center;
        background-repeat: no-repeat;
      }

      span {
        font-weight: 500;
        white-space: nowrap;
      }
    }
  }
}
</style>
